module.exports = __webpack_public_path__ + "images/goods-details-match-light.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/goods-details-match-light.png
// module id = 853
// module chunks = 124